/**
 * Ícones da tela de entrada — os mesmos traços do design aprovado.
 * Todos decorativos (aria-hidden): o nome acessível fica no botão/rótulo.
 */
import React from "react";

const TRACO = {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": "true",
  focusable: "false",
};

function Icone({ tamanho = 18, espessura = 1.8, viewBox = "0 0 24 24", children, ...resto }) {
  return (
    <svg width={tamanho} height={tamanho} viewBox={viewBox} strokeWidth={espessura} {...TRACO} {...resto}>
      {children}
    </svg>
  );
}

/** Três barras da marca Pharu, na cor de destaque. */
export function SimboloPharu({ tamanho = 22, cor = "var(--a)" }) {
  return (
    <svg width={tamanho} height={tamanho} viewBox="0 0 22 22" aria-hidden="true" focusable="false">
      <rect x="2" y="3" width="18" height="3.4" rx="1.2" fill={cor} />
      <rect x="2" y="8.6" width="12" height="3.4" rx="1.2" fill={cor} opacity=".75" />
      <rect x="2" y="14.2" width="15" height="3.4" rx="1.2" fill={cor} opacity=".5" />
    </svg>
  );
}

export const IconeSol = () => (
  <Icone>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
  </Icone>
);

export const IconeLua = () => (
  <Icone>
    <path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z" />
  </Icone>
);

export const IconePredio = () => (
  <Icone tamanho={14}>
    <rect x="4" y="3" width="16" height="18" rx="1.5" />
    <path d="M9 7h1M14 7h1M9 11h1M14 11h1M9 15h1M14 15h1" />
  </Icone>
);

export const IconeEmail = () => (
  <Icone>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="m3 7 9 6 9-6" />
  </Icone>
);

export const IconeCadeado = () => (
  <Icone>
    <rect x="4" y="11" width="16" height="10" rx="2" />
    <path d="M8 11V7a4 4 0 0 1 8 0v4" />
  </Icone>
);

export const IconeOlho = () => (
  <Icone>
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" />
    <circle cx="12" cy="12" r="3" />
  </Icone>
);

export const IconeOlhoRiscado = () => (
  <Icone>
    <path d="M3 3l18 18" />
    <path d="M10.6 5.1A10.4 10.4 0 0 1 12 5c6.5 0 10 7 10 7a17 17 0 0 1-3.2 4.1M6.6 6.6C3.9 8.4 2 12 2 12s3.5 7 10 7a9.7 9.7 0 0 0 5.4-1.6" />
    <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
  </Icone>
);

export const IconeAlerta = () => (
  <Icone tamanho={14} espessura={2}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 8v4M12 16h.01" />
  </Icone>
);

export const IconeCapsLock = () => (
  <Icone tamanho={14} espessura={2}>
    <path d="M12 4 4 12h4v7h8v-7h4z" />
  </Icone>
);

export const IconeEntrar = () => (
  <Icone espessura={2}>
    <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
    <path d="M10 17l5-5-5-5" />
    <path d="M15 12H3" />
  </Icone>
);

export const IconeCheck = ({ tamanho }) => (
  <Icone tamanho={tamanho} espessura={2.4}>
    <path d="M20 6 9 17l-5-5" />
  </Icone>
);

export const IconeVoltar = () => (
  <Icone tamanho={16} espessura={2}>
    <path d="M19 12H5M11 18l-6-6 6-6" />
  </Icone>
);

export const IconeEscudo = () => (
  <Icone tamanho={24}>
    <path d="M12 3 4.5 6v5.5c0 4.6 3.2 8.4 7.5 9.5 4.3-1.1 7.5-4.9 7.5-9.5V6z" />
    <path d="m8.8 12.2 2.2 2.2 4.4-4.6" />
  </Icone>
);

export const IconeChave = () => (
  <Icone>
    <circle cx="7.5" cy="15.5" r="4.5" />
    <path d="m10.7 12.3 9.3-9.3M17 6l3 3M14.5 8.5l2 2" />
  </Icone>
);

export const IconeDocumento = () => (
  <Icone>
    <path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" />
    <path d="M14 3v6h6M8 13h8M8 17h5" />
  </Icone>
);

export const IconeLinhas = () => (
  <Icone>
    <path d="M4 6h10M4 12h16M4 18h7" />
  </Icone>
);

export const IconeCaixa = () => (
  <Icone>
    <path d="M21 8 12 3 3 8v8l9 5 9-5z" />
    <path d="M3 8l9 5 9-5M12 13v8" />
  </Icone>
);

export const IconeFerramenta = () => (
  <Icone>
    <path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4l-2.6 2.6-2.4-.6-.6-2.4z" />
  </Icone>
);

export const IconeTesoura = () => (
  <Icone>
    <circle cx="6" cy="6" r="3" />
    <circle cx="6" cy="18" r="3" />
    <path d="M20 4 8.1 15.9M14.5 14.5 20 20M8.1 8.1 12 12" />
  </Icone>
);
